export const handleAdClick = (event) => {
  const clickFromAd = event.origin.endsWith('safeframe.googlesyndication.com')

  if (!clickFromAd || !window.googleAdIframes) {
    return;
  }

  const matchedIframe = window.googleAdIframes.find((iframe) => {
    return event.source.window === iframe.contentWindow;
  });

  if (matchedIframe) {
    const parentElement = matchedIframe.parentElement.parentElement;
    const clickDataElement = parentElement.getElementsByClassName('click_data_element')[0];
    Object.assign(clickDataElement.dataset, event.data.dataset);
    clickDataElement.innerText = event.data.text;

    window.dataLayer.push({
      event: 'gtm.click',
      'gtm.element': clickDataElement,
      'gtm.elementUrl': new URL(event.data.href).searchParams.get('adurl'),
    });
  }
}
